import { removeMessageListener } from '@dvag/dfs-orchestrator-client';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { addCustomMessageListener } from '@dvag/dfs-orchestrator-client/listeners';

export function useFavoritesUpdatedListener() {
  const queryClient = useQueryClient();

  useEffect(() => {
    const customMsgId = addCustomMessageListener('favoritesUpdated', () =>
      queryClient.invalidateQueries({ queryKey: ['getUserFavorites'] }),
    );
    return () => {
      removeMessageListener(customMsgId);
    };
  }, [queryClient]);
}
